import React from 'react';
import { Menu } from '@headlessui/react'
import Icon from '../Icons/Icon'
import {classNames} from '../../Services/helpers';
import { Link } from 'react-router-dom';
import { useSession } from '../Session';

const Item = ({index, hidden, title, div, section, to, icon, onClick, isSelected, role, small, preventClosing, disabled = false}) => {
    const {isRoleSufficient} = useSession();

    const roleInsufficient = !!(role && !isRoleSufficient(role));

    if (hidden) {
        return null;
    }

    if (div) {
        return <hr />
    }

    if (section) {
        return <Menu.Item>
            {({ active }) => <span className={classNames(
                index !== 0 && 'border-t',
                'text-muted text-xs tracking-wider font-semibold px-4 py-2 block'
            )}>
                {section}
            </span>}
        </Menu.Item>
    }

    const handleClick = (e) => {
        if (preventClosing) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (disabled || roleInsufficient) {
            return;
        }

        if (onClick) {
            onClick();
        }
    }

    return <Menu.Item>
        {({ active }) => {
            const className = classNames(
                !(disabled || roleInsufficient) && ((active || isSelected) ? 'bg-gray-100 text-gray-900 fill-gray-600' : 'text-gray-700 fill-gray-400'),
                'group flex items-center px-4 py-2',
                (disabled || roleInsufficient) && 'cursor-not-allowed text-gray-400 fill-gray-400',
                small ? 'text-xs font-bold text-muted' : 'text-sm font-normal'
            );
            const theIcon = icon ? <Icon icon={icon} size="0.5x" inline className="mr-3 h-5 w-5" /> : null;

            if (to && !roleInsufficient && !disabled) {
                return <Link to={to} className={className}>
                    {theIcon}
                    {title}
                </Link>
            }

            return <span className={className} onClick={handleClick}>
                {theIcon}
                {title}
            </span>
        }}
    </Menu.Item>
}

export default Item;
